// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"44c614f4","453":"3922d9eb","732":"82c161ab","977":"3ccc68ee"}[chunkId] + ".chunk.js";
};